import { Button, IconButton, useTheme, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import slugify from 'slugify';
import { Role } from 'API';
import FieldRoleVisibility from 'components/forms/FieldRoleVisibility';
import CardHeaderText from './CardHeaderText';
import IconCircle from './IconCircle';
import IconRow from './IconRow';
import IconRowCell from './IconRowCell';


interface Props {
  editActions?: React.ReactNode;
  actionsAtTop?: boolean;
  canEditForm?: boolean;
  handleEdit?: () => void;
  onClickAdd?: () => void;
  fullBleedCard?: boolean;
  icon?: Icon;
  isEditing?: boolean;
  canAdd?: boolean;
  cardVisibilityRoles?: Role[];
  noHeaderIcon?: boolean;
  resetEdits?: () => void;
  saveEdits?: () => void;
  title: string
}

const CardHeader: React.FC<Props> = ({
  icon,
  actionsAtTop = true,
  canEditForm,
  fullBleedCard,
  handleEdit,
  onClickAdd,
  isEditing,
  cardVisibilityRoles,
  noHeaderIcon,
  title,
  resetEdits,
  saveEdits,
  editActions,
  canAdd,
}: Props) => {
  const theme = useTheme();

  return (
    <IconRow
      style={fullBleedCard ? { padding: '0 1rem' } : undefined}
      isHeader
      noIcon={!icon || noHeaderIcon}
    >
      {icon && !noHeaderIcon && (
        <IconRowCell type="icon">
          <IconCircle Icon={icon} />
        </IconRowCell>
      )}
      <IconRowCell type="text">
        <Box style={{ position: 'relative', display: 'inline-block', paddingBottom: '1px' }}>
          <CardHeaderText title={title} />
          {cardVisibilityRoles?.length && (
            <FieldRoleVisibility
              roles={cardVisibilityRoles}
            />
          )}
        </Box>
      </IconRowCell>
      {((resetEdits && saveEdits && canEditForm) || (onClickAdd && canAdd))
        && (
          <IconRowCell type="actions">
            {canAdd && (
              <IconButton onClick={onClickAdd} sx={{ padding: 0 }} size="large">
                <AddCircleOutlineIcon style={{
                  color: theme.palette.primary.main,
                }}
                />
              </IconButton>
            )}
            {canEditForm && (
              <>
                {isEditing ? (
                  actionsAtTop && editActions
                ) : (
                  <Button
                    sx={(t) => ({ background: 'transparent', boxShadow: 'none', borderRadius: 0, marginLeft: '1rem', paddingLeft: '1rem', color: t.palette.primary1 })}
                    onClick={handleEdit}
                    id={`${slugify(title)}-edit`}
                  >
                    <EditIcon />
                  </Button>
                )}
              </>
            )}
          </IconRowCell>
        )}
    </IconRow>
  );
};

export default CardHeader;
